import { ReactNode } from "react";
import classNames from "classnames";
import { Row } from "react-bootstrap";
import styles from "./PageTitle.module.css";

type TitlePageModel = {
  title: string | ReactNode;
  icon: ReactNode;
  right?: ReactNode;
};

const PageTitle = ({ title, icon, right }: TitlePageModel) => {
  return (
    <Row>
      <h1 className={classNames(styles.title, "text-primary-100 mb-4")}>
        <span className={"me-2 text-primary"}>{icon}</span>
        {title}
      </h1>
      {right ? <div className={styles.right}>{right}</div> : ""}
    </Row>
  );
};

export default PageTitle;
